<app-table
    tableKey="serviceMailWidget"
    [gridData]="$any(store.data.getServiceMails())"
    [hideCheckboxes]="true"
    [columns]="columns()"
    translatePrefix="service.mailRecords."
    [showSearch]="false"
    [showColumnVisiblity]="true"
    [showExport]="false"
    [showClearFilter]="false"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getServiceMails"
    [refreshCallbackFragment]="getMailsFrag"
    [defaultSorters]="[{ column: 'mailNumber', direction: 'DESC' }]"
>
    <ng-template pTemplate="users" let-data="data">
        <div class="flex flex-column gap-small">
            @for (user of data; track user.id) {
                <app-user-chip
                    [user]="user"
                ></app-user-chip>
            }
        </div>
    </ng-template>
</app-table>
